import Axios from '../Axios';

const entity = {
	create(data) {
		return Axios.post('/entities', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get('/entities?limit=' + limit + '&page=' + page + search);
	},
	readOne(id) {
		return Axios.get('/entities/' + id);
	},
	update(id, data) {
		return Axios.put('/entities/' + id, data);
	},
	delete(id) {
		return Axios.delete('/entities/' + id);
	},
};

export default entity;
